import { appendCurrentLocationAsFrom } from "../reviewsBreadcrumbs";

/** Build a view-review href that carries the originating table URL as `from` so the breadcrumb can return there. */
export const toViewReviewUrl = (reviewId: string): string => appendCurrentLocationAsFrom(`/view-review/${reviewId}/`);
